<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Hasil Penilaian - Matrikulasi'">
          <template v-slot:toolbar>
            <ButtonComponent colors="#3751E4" name="tambah" v-b-modal.modal @click.native="openModal('Tambah')">
            </ButtonComponent>
          </template>
          <template v-slot:body>
            <v-card>
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field v-model="code4.search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="code4.headers" :items="code4.desserts" :search="code4.search">
                <template v-slot:item.no="{ index }">
                  {{ index + 1 }}.
                </template>
                <template v-slot:item.status="{ item }">
                  <b-badge v-if="item.status === true" class="mr-1" variant="primary">Aktif</b-badge>
                  <b-badge v-else class="mr-1" variant="danger">Tidak Aktif</b-badge>
                </template>
                <template v-slot:item.action="{ item }">
                  <ButtonComponent colors="#3751E4" name="edit" v-b-modal.modal @click.native="openModal('Edit')">
                  </ButtonComponent>
                  <ButtonComponent colors="#EF4848" name="hapus"></ButtonComponent>
                </template>
              </v-data-table>
            </v-card>
          </template>
        </KTCodePreview>
        <b-modal ok-title="Simpan" ok-variant="primary" cancel-title="Batal" cancel-variant="danger" id="modal"
          :title="`${statusModal} Penilaian Matrikulasi`">
          <b-form>
            <div class="row">
              <div class="col-lg-6">
                <b-form-group id="input-group-1" label="Nama Mess :" label-for="input-1">
                  <b-form-input id="input-1" type="text" required placeholder="Masukkan Nama Mess"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-6">
              </div>
              <!-- br -->
              <div class="col-lg-6">
                <b-form-group id="input-group-1" label="Nama Mess :" label-for="input-1">
                  <b-form-input id="input-1" type="text" required placeholder="Masukkan Nama Mess"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-6">
                <b-form-group id="input-group-1" label="Nama Mess :" label-for="input-1">
                  <b-form-input id="input-1" type="text" required placeholder="Masukkan Nama Mess"></b-form-input>
                </b-form-group>
              </div>
              <!-- br -->
              <div class="col-lg-6">
                <b-form-group id="input-group-1" label="Nama Mess :" label-for="input-1">
                  <b-form-input id="input-1" type="text" required placeholder="Masukkan Nama Mess"></b-form-input>
                </b-form-group>
              </div>
              <div class="col-lg-6">
                <b-form-group label="Status Dosen">
                  <b-form-radio-group id="pilihStatusDosen">
                    <b-form-radio value="utama">Teknik Mesin Kapal</b-form-radio>
                    <b-form-radio value="cadangan">Manajemen Pertahanan Mantra Laut</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </div>
              <div class="col-lg-12">
                <b-form-group id="input-group-1" label="Nama Mess :" label-for="input-1">
                  <b-form-textarea rows="4" placeholder="Masukkan Alamat Institusi"></b-form-textarea>
                </b-form-group>
              </div>
            </div>
          </b-form>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue"

export default {
  data() {
    return {
      code4: {
        search: "",
        headers: [
          {
            text: "No",
            value: "no"
          },
          { text: "Nama", value: "name" },
          { text: "Nilai Komponen 1", value: "nilai_1" },
          { text: "Nilai Komponen 2", value: "nilai_2" },
          { text: "Nilai Akhir", value: "nilaiAkhir" },
          { text: "Rekomendasi Prodi", value: "recomendation" },
          { text: "Keterangan", value: "description" },
          { text: "Aksi", value: "action" }
        ],
        desserts: [
          {
            no: 1,
            name: "Hilal",
            nilai_1: "89",
            nilai_2: "92",
            nilaiAkhir: "90",
            recomendation: "Teknik Mesin Kapal",
            description: "-",
          }
        ]
      },
      statusModal: ''
    };
  },
  components: {
    KTCodePreview,
    ButtonComponent
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Master" },
      { title: "Mess" }
    ]);
  },
  methods: {
    openModal(status) {
      this.statusModal = status
    }
  }
}
</script>